import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TBlock, TStylesIndex } from './models';

export const Block: FC<TBlock> = props => {
    const {
        border,
        borderColor,
        borderRadius,
        children,
        className,
        dataTestId,
        fullHeight,
        id,
        inner,
        innerRef,
        notPadded,
        overflowHidden,
        paddedType = 'standard',
        shadow = false,
        styles,
        theme = 'transparent',
        ...rest
    } = props;

    const borderStyles: Partial<Record<TStylesIndex, string | number>> = {};

    /*
     * TODO: Бордер пока в camelCase не перевести быстро, так как в пропс передаются значения такого типа dark-indigo-20
     * Плюс нужно учесть обратную совместимость в ASSR
     */
    if (typeof borderColor !== 'undefined') {
        borderStyles[styles[`border-${borderColor}`] as TStylesIndex] = borderColor;
    }

    if (typeof borderRadius !== 'undefined' && borderRadius !== false) {
        // Для обратной совместимости, когда borderRadius был true/false, и в случае true был равен 4px
        const borderRadiusSize = borderRadius === true ? 4 : borderRadius;

        borderStyles[styles[`borderRadius${borderRadiusSize}`] as TStylesIndex] = borderRadiusSize;
    }

    const classNames = cn(
        styles.block,
        styles[theme],
        {
            [styles[paddedType]]: !notPadded,
            [styles.inner]: inner,
            [styles.border]: border && !borderColor,
            ...borderStyles,
            [styles.fullHeight]: fullHeight,
            [styles.shadow]: shadow,
            [styles.overflowHidden]: overflowHidden,
        },
        className
    );

    return (
        <div ref={innerRef} className={classNames} data-test-id={dataTestId} id={id} {...rest}>
            {children}
        </div>
    );
};
